import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Col, Form, Input, Row } from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import RouterPropTypes from 'react-router-prop-types';

import globalTranslations from '../../../i18n/globalTranslations';
import ProductListFilter from '../../product-list/ProductListFilter';
import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';
import { parse } from '../../../util/queryString';
import OrderListSortSelection from '../OrderListSortSelection';
import AccountStore from '../../../store/AccountStore';
import classNames from 'classnames';

@observer
export class OrderListHeading extends Component {
  // Have to use class component until we have react router v5.1 hooks version
  // Functional component with withRouter HOC causes infinite loops
  constructor(props) {
    super(props);
    this.formName = 'OrderListHeadingDateFilters';

    const { location } = this.props;

    this.state = {
      startDate: parse(location.search).startDate || '',
      endDate: parse(location.search).endDate || '',
    };
  }

  componentDidUpdate() {
    const { startDate, endDate } = this.state;
    this.props.onFilterByDate(startDate, endDate);
  }

  renderProductListFilter = () => {
    const {
      uiStore,
      intl,
      location,
      onClearProductListFilter,
      onFilterByText,
    } = this.props;
    const placeholder = intl.formatMessage(globalTranslations.search);

    return (
      <Col
        xs={!uiStore.isLargest && '12'}
        className="OrderListHeading__text-filter"
      >
        <ProductListFilter
          onProductListFiltering={onFilterByText}
          clearProductListFilter={onClearProductListFilter}
          searchTerm={parse(location.search).text}
          hideButtonText={true}
          overridePlaceholder={placeholder}
        />
      </Col>
    );
  };

  updateStartDate = (e) => {
    this.setState({
      startDate: e.target.value,
    });
  };

  updateEndDate = (e) => {
    this.setState({
      endDate: e.target.value,
    });
  };

  renderDateFilters = () => {
    const { startDate, endDate } = this.state;

    return (
      <Col>
        <Form className="OrderListHeading__date-filters" noValidate>
          <Input
            value={startDate}
            className="OrderListHeading__min-date"
            type="date"
            name={'startDate'}
            max={endDate}
            onKeyDown={(e) => e.preventDefault()}
            onChange={this.updateStartDate}
          />
          <span className="OrderListHeading__dash">-</span>
          <Input
            value={endDate}
            className="OrderListHeading__max-date"
            type="date"
            name={'endDate'}
            min={startDate}
            onKeyDown={(e) => e.preventDefault()}
            onChange={this.updateEndDate}
          />
        </Form>
      </Col>
    );
  };

  renderSortSelection = () => {
    const {
      onSelectSort,
      onSelectSortOrder,
      selectedSortOrder,
      selectedSortOrderBy,
    } = this.props;

    return (
      <Col xs="auto" className="OrderListHeading__sort-selection">
        <OrderListSortSelection
          sortSelections={this.orderListSortSelections}
          onSelectSort={onSelectSort}
          onSelectSortOrder={onSelectSortOrder}
          selectedSortKey={selectedSortOrderBy}
          selectedSortOrder={selectedSortOrder}
        />
      </Col>
    );
  };

  renderOrderListFilters = () => {
    const { uiStore } = this.props;

    return (
      <>
        {this.renderSortSelection()}
        {!uiStore.isLargest && this.renderDateFilters()}
        {this.renderProductListFilter()}
        {uiStore.isLargest && this.renderDateFilters()}
      </>
    );
  };

  renderOrderCount = () => {
    const { orderCount, showFilters } = this.props;
    return (
      <Col
        xs="auto"
        className={classNames('OrderListHeading__order-count', {
          'OrderListHeading__order-count--no-filters': !showFilters,
        })}
      >
        <FormattedMessage
          {...globalTranslations.orderCountSentence}
          values={{ count: orderCount }}
        />
      </Col>
    );
  };

  render() {
    const { accountStore, configStore, showFilters } = this.props;

    return (
      <div className="OrderListHeading">
        <Row>
          {this.renderOrderCount()}
          {(accountStore.isRetailer ||
            configStore.orderHistory.enableFilters) &&
            showFilters &&
            this.renderOrderListFilters()}
        </Row>
      </div>
    );
  }
}

OrderListHeading.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  intl: intlShape.isRequired,
  location: RouterPropTypes.location.isRequired,
  onClearProductListFilter: PropTypes.func.isRequired,
  onFilterByDate: PropTypes.func.isRequired,
  onFilterByText: PropTypes.func.isRequired,
  onSelectSort: PropTypes.func.isRequired,
  onSelectSortOrder: PropTypes.func.isRequired,
  orderCount: PropTypes.number,
  selectedSortOrder: PropTypes.string,
  selectedSortOrderBy: PropTypes.string,
  showFilters: PropTypes.bool,
};

OrderListHeading.defaultProps = {
  orderCount: 0,
  showFilters: true,
};

export default withRouter(
  injectIntl(inject('accountStore', 'configStore', 'uiStore')(OrderListHeading))
);
